import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Modal } from 'antd';

import './style.css';

const SUPPORT_EMAIL = 'sandos4u.mx@sandos.com';

const ModalActivationLinkSent = ({ visible, onClose }, context) => {
  const t = context.t;

  return (
    <Modal
      visible={visible}
      footer={null}
      centered
      width={480}
      zIndex={1100}
      onCancel={onClose}
      className="activation-link-sent-modal"
      destroyOnClose
    >
      <div className="activation-link-sent">
        <Icon type="check-circle" theme="filled" className="activation-link-sent__icon" />
        <h3 className="activation-link-sent__title">
          {t('Link sent successfully')}
        </h3>
        <p className="activation-link-sent__text">
          {t('Check your email.')}
          <br />
          {t('We have sent you a new link to complete your registration.')}
        </p>
        <div className="activation-link-sent__help">
          <span>{t('Need help?')}</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="activation-link-sent__contact">
            {t('Contact us')}
          </a>
        </div>
      </div>
    </Modal>
  );
};

ModalActivationLinkSent.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ModalActivationLinkSent.defaultProps = {
  visible: false,
};

ModalActivationLinkSent.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default ModalActivationLinkSent;
